import React from 'react'
import styled from '@emotion/styled'

import Modal from '../../ui/Modal'
import { dimensions } from '../../../styles/variables'
import { MediaVideo } from '../../Media'
import Media from '../../Media'

const StyledModalContent = styled.div`
	background-color: #d5ced5;
	border: 1px solid rgba(0, 0, 0, 0.2);

	.modal-header,
	.modal-body,
	.modal-footer {
		padding: ${dimensions.containerPadding / 2}rem ${dimensions.containerPadding}rem;
	}

	.modal-header {
		display: flex;
		justify-content: flex-end;
		border-bottom: 1px solid #a697a6;

		button {
			border: 0;
			cursor: pointer;
			font-size: ${dimensions.fontSize.large}rem;
			background-color: transparent;
			margin-top: ${-dimensions.containerPadding / 2}rem;
			margin-right: ${-dimensions.containerPadding}rem;
		}
	}

	.modal-footer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		border-top: 1px solid #a697a6;
	}
`

interface Props {
	embed: MediaVideo
	/** Modal open state */
	isOpen: boolean
	/** Modal toggle */
	toggle: () => void
}

const WatchMoreModal: React.FC<Props> = ({ embed, isOpen, toggle }) => (
	<Modal isOpen={isOpen} toggle={toggle} labelledBy="modal-title" backgroundCanClose>
		<StyledModalContent>
			<div className="modal-header">
				<button type="button" aria-label="Close" onClick={toggle}>
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<Media source={embed} />
		</StyledModalContent>
	</Modal>
)

export default WatchMoreModal
